import React from 'react';
import LargeRectangleButton from './LargeRectangleButton';
import { RectangleButtonProps } from './RectangleButton';

const LargeGreyButton = ({ className, ...rest }: RectangleButtonProps) => {
  return (
    <LargeRectangleButton
      className={'bg-light-slate-gray ' + className}
      {...rest}
    ></LargeRectangleButton>
  );
};

export default LargeGreyButton;
